export default "__VITE_PUBLIC_ASSET__3754da7e__"